import { render, staticRenderFns } from "./InviteCard.vue?vue&type=template&id=4f5bf15c&"
import script from "./InviteCard.vue?vue&type=script&lang=js&"
export * from "./InviteCard.vue?vue&type=script&lang=js&"
import style0 from "./InviteCard.vue?vue&type=style&index=0&id=4f5bf15c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports